import ajax from "./ajax";

// Duplicate placement: copy one placement's setup to another and move designs.
// Node API: routes/settings.js + functions/placements/duplicateJob.js.

/** { source, target, blanks, machines, pricingTables, listings, sellers } */
export const previewPlacementDuplicate = (data) =>
  ajax("/settings/placements/duplicate/preview", {
    method: "POST",
    data,
    timeout: 120000,
  });

/** { products: [{ id, name, brand, style, targetOn }], inherited } — products with the source on. */
export const listPlacementDuplicateProducts = (data) =>
  ajax("/settings/placements/duplicate/products", {
    method: "POST",
    data,
    timeout: 60000,
  });

/** The queued job (tracker shape). */
export const startPlacementDuplicate = (data) =>
  ajax("/settings/placements/duplicate", { method: "POST", data, timeout: 60000 });

export const listActivePlacementJobs = () =>
  ajax("/settings/placement-jobs", { query: { active: "true" } });

export const getPlacementJob = (jobId) =>
  ajax(`/settings/placement-jobs/${encodeURIComponent(jobId)}`);

export const getPlacementJobResults = (jobId, status) => {
  const list = Array.isArray(status) ? status.join(",") : status;
  return ajax(`/settings/placement-jobs/${encodeURIComponent(jobId)}/results`, {
    query: list ? { status: list } : undefined,
  });
};

export const cancelPlacementJob = (jobId) =>
  ajax(`/settings/placement-jobs/${encodeURIComponent(jobId)}/cancel`, {
    method: "POST",
  });

export const dismissPlacementJob = (jobId) =>
  ajax(`/settings/placement-jobs/${encodeURIComponent(jobId)}/dismiss`, {
    method: "POST",
  });

export const retryPlacementJob = (jobId) =>
  ajax(`/settings/placement-jobs/${encodeURIComponent(jobId)}/retry`, {
    method: "POST",
  });

export const undoPlacementJob = (jobId) =>
  ajax(`/settings/placement-jobs/${encodeURIComponent(jobId)}/undo`, {
    method: "POST",
  });
